import { render, staticRenderFns } from "./StatsDailyMocktest.vue?vue&type=template&id=530ee904&"
import script from "./StatsDailyMocktest.vue?vue&type=script&lang=js&"
export * from "./StatsDailyMocktest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports